module.exports = __webpack_public_path__ + "static/media/LG_FilterTour_s3.dfb1b98c.gif";